// Dynamic Contact Form Auto-Population
// Automatically fills contact form message with current product info

(function() {
  'use strict';
  
  function initDynamicContactForm() {
    console.log('🔄 Initializing dynamic contact form...');
    
    // Check if we're on a product page
    if (!document.body.classList.contains('template-product')) {
      console.log('ℹ️ Not on product page, skipping auto-population');
      return;
    }
    
    // Get product information
    const productInfo = getProductInfo();
    
    if (!productInfo.title) {
      console.log('⚠️ No product information found');
      return;
    }
    
    // Find contact form message fields and populate them
    populateContactForms(productInfo);
    
    console.log('✅ Dynamic contact form initialized');
  }
  
  function getProductInfo() {
    const productInfo = {
      title: '',
      referenceCode: '',
      handle: ''
    };
    
    // Try to get product title from various sources
    const titleSelectors = [
      'h1.product-title',
      'h1[data-product-title]',
      '.product-name h1',
      '.product-header h1',
      'h1.heading-style-h1',
      'h1'
    ];
    
    for (const selector of titleSelectors) {
      const titleEl = document.querySelector(selector);
      if (titleEl && titleEl.textContent.trim()) {
        productInfo.title = titleEl.textContent.trim();
        break;
      }
    }
    
    // Try to get reference code from various sources
    const refCodeSelectors = [
      '#ref-code-text',
      '[data-ref-code]',
      '.ref-code',
      '.reference-code',
      '.sku'
    ];
    
    for (const selector of refCodeSelectors) {
      const refEl = document.querySelector(selector);
      if (refEl && refEl.textContent.trim()) {
        const refText = refEl.textContent.trim();
        // Extract the code part after "Reference code:" including brackets
        // e.g., "Reference code: [SL] JM-JB01-28R-MB" -> "[SL] JM-JB01-28R-MB"
        const codeMatch = refText.match(/Reference code:\s*(.+)$/i);
        if (codeMatch) {
          productInfo.referenceCode = codeMatch[1].trim();
          break;
        }
        // Fallback: extract any alphanumeric code pattern
        const fallbackMatch = refText.match(/([A-Z0-9\[\]\s-]+(?:-[A-Z0-9]+)*)/);
        if (fallbackMatch) {
          productInfo.referenceCode = fallbackMatch[1];
          break;
        }
      }
    }
    
    // Fallback: try to get reference code from URL or meta tags
    if (!productInfo.referenceCode) {
      // Try to get from meta tags
      const skuMeta = document.querySelector('meta[property="product:retailer_item_id"]');
      if (skuMeta) {
        productInfo.referenceCode = skuMeta.getAttribute('content');
      }
    }
    
    // Get product handle from URL
    const urlParts = window.location.pathname.split('/');
    if (urlParts.includes('products') && urlParts.length > 2) {
      const productIndex = urlParts.indexOf('products');
      if (productIndex >= 0 && urlParts[productIndex + 1]) {
        productInfo.handle = urlParts[productIndex + 1];
      }
    }
    
    console.log('📋 Product info extracted:', productInfo);
    return productInfo;
  }
  
  function populateContactForms(productInfo) {
    // Find all contact form message fields
    const messageSelectors = [
      '#CustomContactForm3-body',
      '#CustomContactForm-body', 
      '#Message-3',
      'textarea[name="contact[body]"]',
      'textarea[placeholder*="message"]',
      'textarea[placeholder*="Message"]'
    ];
    
    let populatedCount = 0;
    
    messageSelectors.forEach(selector => {
      const messageField = document.querySelector(selector);
      if (messageField && !messageField.value.trim()) {
        const message = generateMessage(productInfo);
        messageField.value = message;
        populatedCount++;
        
        console.log('✅ Populated message field:', selector);
        
        // Trigger change event to notify any form validation
        messageField.dispatchEvent(new Event('change', { bubbles: true }));
        messageField.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    console.log(`📝 Populated ${populatedCount} message field(s)`);
  }
  
  function generateMessage(productInfo) {
    let message = "I'm inquiring about ";
    
    // Add product title if available
    if (productInfo.title) {
      // Clean up the title (remove extra text like "· Modern L-Shaped Executive Desk")
      const cleanTitle = productInfo.title
        .replace(/·.*$/, '') // Remove everything after ·
        .replace(/\s+/g, ' ') // Normalize spaces
        .trim();
      
      message += `the ${cleanTitle}`;
    } else {
      message += "this product";
    }
    
    // Add reference code if available
    if (productInfo.referenceCode) {
      message += `, (Reference code: ${productInfo.referenceCode})`;
    }
    
    message += ".";
    
    return message;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDynamicContactForm);
  } else {
    initDynamicContactForm();
  }
  
  // Also initialize after a delay to catch any dynamically loaded content
  setTimeout(initDynamicContactForm, 1000);
  
  // Re-initialize when navigating between pages (for SPA-like behavior)
  window.addEventListener('popstate', () => {
    setTimeout(initDynamicContactForm, 500);
  });
  
  // Make function available globally for debugging
  window.dynamicContactForm = {
    init: initDynamicContactForm,
    getProductInfo: getProductInfo,
    populateContactForms: populateContactForms
  };
  
})();
